import Pagination from 'antd/es/pagination/Pagination';
import styled from 'styled-components';
export const PaginationStyled = styled(Pagination) ``;
